import { ContractRecord, DegreeProgramRecord } from 'lib/DataModel'
import PromisedResource from './PromisedResource'

const getDegreePrograms = (remote, contract: ContractRecord, includeExclusionRules: boolean) => (
  remote.query(q =>
    q.findRelatedRecords(contract, 'degreePrograms'), includeExclusionRules ? {
      sources: {
        remote: {
          include: ['exclusion_rules']
        }
      }
    } : {}
  )
)

export default class DegreeProgramsResource extends PromisedResource<DegreeProgramRecord[]> {
  constructor({ remote, contract, includeExclusionRules=false }) {
    super(getDegreePrograms(remote, contract, includeExclusionRules))
  }
}
